import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { onHandlerHideView } from '../handler/ViewHandler';
import Utils from "@/common/utils/utils";
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmHideView = (props) => {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        props.setIsConfirmHideView(false);
    };

    const showMsgConfirmHideView = () => {
        if (Utils.isEmptyArray(props?.chatbotCategories)) return trI18n('COMMSG032');

        const viewIdsOfChatbotCategories = props?.chatbotCategories?.map(
            i => i?.chatBotCategorySetting?.viewId
        );
        
        if (viewIdsOfChatbotCategories?.includes(props?.view?.id))
            return trI18n('MSG-KNOW-HIDE-VIEW-SETTING-CATEGORY');

        return trI18n('COMMSG032');
    };

    return (
        <Dialog
            open={props.isConfirmHideView}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                   {showMsgConfirmHideView()}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={() => onHandlerHideView(props.view, props)}
                    className="btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                >
                    {tr('はい')}
                </Button>
                <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {tr('いいえ')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
